// newTemplateListSlice.ts
import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { Template } from '../interfaces/reducersInterfaces';
import { RootState } from '../store';
import { addEsChatToConfig } from "../../Utils/apiUtils";
import axios from 'axios';

interface NewTemplateListState {
  templates: Template[];
  selectedTemplate: Template | null;
  loading: boolean;
  error: string | null;
  count: number;
}

const initialState: NewTemplateListState = {
  templates: [],
  selectedTemplate: null,
  loading: false,
  error: null,
  count: 0
};

export const fetchNewTemplates = createAsyncThunk(
    'newTemplateList/fetchTemplates',
    async () => {
      const config = addEsChatToConfig();
      
      const response = await axios.get('https://api.insightssystem.com/api:bVXsw_FD/web/templates', config);
      return response.data as Template[];
    }
  );

const newTemplateListSlice = createSlice({
  name: 'newTemplateList',
  initialState,
  reducers: {
    setNewSelectedTemplate: (state, action: PayloadAction<Template | null>) => {
      state.selectedTemplate = action.payload;
    },
    clearNewTemplates: (state) => {
      state.templates = [];
      state.selectedTemplate = null;
      state.count = 0;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNewTemplates.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchNewTemplates.fulfilled, (state, action) => {
        state.loading = false;
        state.templates = action.payload;
        state.count = action.payload.length;
        state.error = null;
      })
      .addCase(fetchNewTemplates.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch templates';
      });
  }
});

export const { setNewSelectedTemplate, clearNewTemplates } = newTemplateListSlice.actions;

export const selectNewTemplates = (state: RootState) => state.newTemplateList.templates;
export const selectNewSelectedTemplate = (state: RootState) => state.newTemplateList.selectedTemplate;
export const selectNewTemplateLoading = (state: RootState) => state.newTemplateList.loading;
export const selectNewTemplateError = (state: RootState) => state.newTemplateList.error;
export const selectNewTemplateCount = (state: RootState) => state.newTemplateList.count;

export default newTemplateListSlice.reducer;